import {
  ApplicationRef,
  Compiler,
  ComponentFactory,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  Injectable,
  Injector,
} from '@angular/core';
import { ResourceManager } from 'libs/abc/core/resources/src/lib/resource-manager';
import { ConfigService } from '../../../../../core/configuration/src/lib/services/config.service';
import { IAbcComponent, StylingMode } from './abcComponent.model';

@Injectable()
export class AbcComponentService {
  private componentRefs: {} = {};
  private loadedModules = [];
  private _stylingMode: StylingMode = StylingMode.Underlined;
  private _rtlEnabled = false;
  componentRef: any;
  component = [];
  private loadedComponents = [];
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private compiler: Compiler,
    private coreConfig: ConfigService
  ) {
    this.stylingMode = <StylingMode>this.coreConfig.getConfiguration().Style.Mode;
    this.rtlEnabled = ResourceManager.getLanguage() === 'ar' ? true : false;
  }

  loadComponent(component: any, viewContainer?: any) {
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);
    this.loadedComponents.push(componentRef);
    const domElement = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    if (viewContainer) {
      viewContainer.insert(componentRef.hostView);
    } else {
      this.appRef.attachView(componentRef.hostView);
      document.body.appendChild(domElement);
    }
    return { componentRef: componentRef, domElement: domElement };
  }

  public resolveComponent<T>(component): ComponentFactory<T> {
    return this.componentFactoryResolver.resolveComponentFactory(component);
  }
  getInstanceById(id: string) {
    return this.componentRefs[id];
  }

  setValue(id: string, value: any) {
    const instance = this.getInstanceById(id);
    instance.value = value;
  }

  addInstance(instance: IAbcComponent) {
    this.componentRefs[instance.id] = instance;
  }

  removeInstance(instance: IAbcComponent) {
    this.componentRefs[instance.id] = null;
  }

  public set stylingMode(mode: StylingMode) {
    if (this.loadedComponents.length > 0) {
      this.loadedComponents.forEach((component) => {
        if (component?.instance?.stylingMode) {
          component.instance.stylingMode = mode;
        }
      });
    }
    this._stylingMode = mode;
  }

  public get stylingMode(): StylingMode {
    return this._stylingMode;
  }

  public set rtlEnabled(rtl: boolean) {
    if (this.loadedComponents.length > 0) {
      this.loadedComponents.forEach((component) => {
        if (component?.instance?.rtlEnabled) {
          component.instance.rtlEnabled = rtl;
        }
      });
    }
    this._rtlEnabled = rtl;
  }

  public get rtlEnabled(): boolean {
    return this._rtlEnabled;
  }
}
